import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { FaCheckCircle, FaClock, FaExclamationCircle } from 'react-icons/fa';
import DetailsButton from './components/DetailsButton';

const Timeline = ({ events, onEventClick }) => {
  if (!events || events.length === 0) {
    return (
      <div className="flex items-center justify-center py-12 text-gray-500">
        <span>No hay eventos para mostrar</span>
      </div>
    );
  }

  const getStatusIcon = (estado, verificado) => {
    if (estado === 'Pagado') {  
      return <FaCheckCircle style={{ fontSize: '14px' }} />;
    } else if (verificado) {
      return <FaExclamationCircle style={{ fontSize: '14px' }} />;
    } else {
      return <FaClock style={{ fontSize: '14px' }} />;
    }
  };

  const getStatusColor = (estado, verificado) => {
    if (estado === 'Pagado') {
      return { background: '#10b981', color: '#fff' }; // green-500
    } else if (verificado) {
      return { background: '#eab308', color: '#fff' }; // yellow-500
    } else {
      return { background: '#ef4444', color: '#fff' }; // red-500
    }
  };

  const getContentColor = (estado, verificado) => {
    if (estado === 'Pagado') {
      return { background: '#d1fae5', color: '#065f46' }; // green-100, green-800
    } else if (verificado) {
      return { background: '#fef9c3', color: '#854d0e' }; // yellow-100, yellow-800
    } else {
      return { background: '#fee2e2', color: '#991b1b' }; // red-100, red-800
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Sin fecha';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Fecha inválida';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <div className="py-4 px-2">
      <VerticalTimeline lineColor="#d1d5db">
        {events.map((event, index) => {
          const iconColor = getStatusColor(event.estado, event.verificado);
          const contentColor = getContentColor(event.estado, event.verificado);
          
          return (
            <VerticalTimelineElement
              key={index}
              className="vertical-timeline-element--work"
              contentStyle={contentColor}
              contentArrowStyle={{ borderRight: `7px solid ${contentColor.background}` }}
              date={formatDate(event.fecha)}
              iconStyle={iconColor}
              icon={getStatusIcon(event.estado, event.verificado)}
            >
              <div className="text-xs">
                {/* Estado y Cliente con botón */}
                <div className="flex items-center justify-between mb-2 gap-2">
                  <div className={`text-xs font-bold px-2 py-1 rounded flex-shrink-0 ${
                    event.estado === 'Pagado' ? 'bg-green-200 text-green-800' : 
                    event.verificado ? 'bg-yellow-200 text-yellow-800' : 'bg-red-200 text-red-800'
                  }`}>
                    {event.estado}
                  </div>
                  <div className="flex items-center gap-2 flex-1 min-w-0 justify-end">
                    <span className="font-semibold text-gray-900 truncate">
                      {event.cliente}
                    </span>
                    {event.cotizacion && onEventClick && (
                      <DetailsButton
                        content={event.cotizacion}
                        action={() => onEventClick(event.cotizacion)}
                      />
                    )}
                  </div>
                </div>

                {/* Monto y Categoría */}
                <div className="flex justify-between items-center gap-3">
                  <div className="flex items-center gap-1 flex-shrink-0">
                    <span className="font-bold text-gray-900">
                      S/. {event.monto.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </span>
                  </div>
                  {event.categoria && (
                    <span className="text-xs font-medium text-gray-700 px-2 py-1 bg-gray-200 rounded">
                      {event.categoria}
                    </span>
                  )}
                </div>
              </div>
            </VerticalTimelineElement>
          );
        })}
      </VerticalTimeline>
    </div>
  );
};

export default Timeline;

